import AppDemo from './components/app-demo-buttons/app-demo.js';

function App() {

	return (
		<AppDemo></AppDemo>	
	);
}

export default App;